module.exports = __webpack_public_path__ + "static/stageSet1-b9da9e34cdcae6ede3ee93edf0025f4b.jpg";